<template>
  <div :class="efClass" class="popArea">
    <div class="defaultSect2 bkPop defaultPop">
      <div class="divInner">
        <div class="bkPop_in_ico">
          <span class="ico_write">
            <img src="@/assets/images/@ico_recruit.png" alt="" />
          </span>
        </div>

        <div class="topPop web">
          <div class="defaultSect2Text">
            <span>우리와 함께 더 좋은 디지털 세상을 만들어봐요.</span>
          </div>
        </div>

        <div class="topPop mobile">
          <div class="defaultSect2Text">
            <span>우리와 함께 더 좋은 </span>
            <span>디지털 세상을 만들어봐요.</span>
          </div>
        </div>

        <div class="writeConArea recruitPop">
          <!--
          <div class="infoTextTop">
            <span class="ico_write">
              <img
                src="@/assets/images/@ico_recruit.png"
                alt=""
              >
            </span>
            <p class="infoTitie web">
              <span>당신에게 일은 어떤 의미인가요? 단순히 생계수단? </span>
              <span>아니면 막연히 해야 하는 것? </span>
              <span>만약 당신에게 있어 일이 자신의 삶을 더욱 풍요롭게 하고, 자신의 꿈을 </span>
              <span>실현할 수 있게 하는 것이라면 </span>
              <span>지금 우리에게 당신의 이야기를 들려주세요. :P</span>
            </p>
            <p class="infoTitie mobile">
              <span>당신에게 일은 어떤 의미인가요? 단순히 </span>
              <span>생계수단? 아니면 막연히 해야 하는 것? </span>
              <span>만약 당신에게 있어 일이 자신의 삶을 더욱 풍요 </span>
              <span>롭게 하고, 자신의 꿈을 실현할 수 있게 하는 것 </span>
              <span>이라면 지금 우리에게 당신의 이야기를 </span>
              <span>들려주세요. :P</span>
            </p>
          </div>
          -->

          <div class="rotateText">
            <p>
              <span>우리와 함께해요 :P</span>
            </p>
          </div>

          <div class="arrow_action">
            <div class="arrow_inr">&nbsp;</div>
          </div>

          <div class="choiceArea">
            <strong class="questionTit">당신은 어떤 전문가이신가요? <sup>*</sup></strong>
            <div class="choInp widthSt1">
              <div class="radio_control lineHeader">
                <input type="radio" name="jobCho" checked="check" id="jC_radio1" value="CON" v-model="expert" />
                <label for="jC_radio1" class="radio_text"><span class="radio_button" />컨설턴트/영업</label>
              </div>
              <div class="radio_control">
                <input type="radio" name="jobCho" id="jC_radio2" value="PLA" v-model="expert" />
                <label for="jC_radio2" class="radio_text"><span class="radio_button" />기획</label>
              </div>
              <div class="radio_control">
                <input type="radio" name="jobCho" id="jC_radio3" value="DGN" v-model="expert" />
                <label for="jC_radio3" class="radio_text"><span class="radio_button" />디자인</label>
              </div>
              <div class="radio_control">
                <input type="radio" name="jobCho" id="jC_radio4" value="PUB" v-model="expert" />
                <label for="jC_radio4" class="radio_text"><span class="radio_button" />퍼블리싱</label>
              </div>
              <div class="radio_control lineHeader linetMgt">
                <input type="radio" name="jobCho" id="jC_radio5" value="SCT" v-model="expert" />
                <label for="jC_radio5" class="radio_text"><span class="radio_button" />스크립트</label>
              </div>
              <div class="radio_control linetMgt">
                <input type="radio" name="jobCho" id="jC_radio6" value="MKT" v-model="expert" />
                <label for="jC_radio6" class="radio_text"><span class="radio_button" />마케팅</label>
              </div>
              <div class="radio_control linetMgt">
                <input type="radio" name="jobCho" id="jC_radio7" value="DEV" v-model="expert" />
                <label for="jC_radio7" class="radio_text"><span class="radio_button" />개발</label>
              </div>
              <div class="radio_control linetMgt linetMgb">
                <input type="radio" name="jobCho" id="jC_radio8" value="ETC" v-model="expert" />
                <label for="jC_radio8" class="radio_text"><span class="radio_button" />기타</label>
              </div>
            </div>
          </div>

          <!-- <div class="choiceArea">
            <strong class="questionTit">플립을 어떻게 알게 됐나요? <sup>*</sup></strong>
            <div class="choInp">
              <div class="radio_control lineHeader">
                <input
                  type="radio"
                  name="howRoute2"
                  checked="check"
                  id="hR_recu_radio1"
                  value="FRI"
                  v-model="pKPath"
                >
                <label
                  for="hR_recu_radio1"
                  class="radio_text"
                ><span class="radio_button" />지인 소개</label>
              </div>
              <div class="radio_control">
                <input
                  type="radio"
                  name="howRoute2"
                  id="hR_recu_radio2"
                  value="POT"
                  v-model="pKPath"
                >
                <label
                  for="hR_recu_radio2"
                  class="radio_text"
                ><span class="radio_button" />포털사이트 검색</label>
              </div>
              <div class="radio_control">
                <input
                  type="radio"
                  name="howRoute2"
                  id="hR_recu_radio3"
                  value="WED"
                  v-model="pKPath"
                >
                <label
                  for="hR_recu_radio3"
                  class="radio_text"
                ><span class="radio_button" />웹 디자인 참고 사이트</label>
              </div>
              <div class="radio_control lineHeader linetMgt">
                <input
                  type="radio"
                  name="howRoute2"
                  id="hR_recu_radio4"
                  value="SNS"
                  v-model="pKPath"
                >
                <label
                  for="hR_recu_radio4"
                  class="radio_text"
                ><span class="radio_button" />플립 SNS (블로그, 페이스북, 유튜브 등)</label>
              </div>
              <div class="radio_control linetMgt">
                <input
                  type="radio"
                  name="howRoute2"
                  id="hR_recu_radio5"
                  value="PRS"
                  v-model="pKPath"
                >
                <label
                  for="hR_recu_radio5"
                  class="radio_text"
                ><span class="radio_button" />언론 보도 기사</label>
              </div>

              <div class="radio_control lineHeader linetMgt rongTabt">
                <div class="etc">
                  <div class="rBtn">
                    <input
                      type="radio"
                      name="howRoute2"
                      id="hR_recu_radio6"
                      value="ETC"
                      v-model="pKPath"
                    >
                    <label
                      for="hR_recu_radio6"
                      class="radio_text"
                    ><span class="radio_button" /></label>
                  </div>

                  <div class="textInp">
                    <input
                      type="text"
                      name="howRoute2TextInp"
                      v-model="pKPathEtc"
                      placeholder="다른 경로로 알게 되셨다면 편하게 말씀해 주세요~!"
                      @focus="pKPath = 'ETC'"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <div class="profileArea">
            <strong class="questionTit mgbSt2">간단한 정보를 입력해 주세요.</strong>
            <div class="profileInp">
              <div class="inpList">
                <ul>
                  <li>
                    <div class="half half_l">
                      <input type="text" name="" placeholder="성함을 말씀해 주세요." v-model="name" />
                      <span class="fstar">*</span>
                    </div>
                    <div class="half half_r">
                      <input type="text" name="" placeholder="경력" v-model="career" />
                      <span class="fstar">*</span>
                    </div>
                  </li>
                  <li>
                    <div class="half half_l">
                      <input type="text" name="" placeholder="이메일을 입력해 주세요." v-model="email" />
                      <span class="fstar">*</span>
                    </div>
                    <div class="half half_r">
                      <input type="text" name="" placeholder="연락처를 입력해주세요." v-model="tel" />
                      <span class="fstar">*</span>
                    </div>
                  </li>
                  <li>
                    <div class="half half_l">
                      <input type="text" name="" placeholder="입사지원서" readonly v-model="file1Name" />
                      <span class="fstar mobile">*</span>
                      <a href="javascript:;" class="addFile" @click.prevent="$refs.file1.click()"><span class="fstar web">*</span>파일첨부</a>
                      <input ref="file1" type="file" name="file1" style="display: none" @change="file1Change" />
                    </div>
                    <div class="half half_r">
                      <input type="text" name="" placeholder="포트폴리오" readonly v-model="file2Name" />
                      <a href="javascript:;" class="addFile" @click.prevent="$refs.file2.click()">파일첨부</a>
                      <input ref="file2" type="file" name="file1" style="display: none" @change="file2Change" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="provision">
            <div class="check_control">
              <ul>
                <li>
                  <div class="boxWrap">
                    <div class="chBoxArea">
                      <input type="checkbox" name="" id="provision3" v-model="agree" />
                      <label for="provision3" class="check_text"><span class="check_button" /></label>
                    </div>
                    <div class="boxText">
                      <p>
                        [필수] <a href="javascript:;" class="privacyBtn" @click.prevent="publicPop = true">개인 정보 수집&bull;이용</a>에 대해
                        동의합니다.
                      </p>
                      <p class="cautionT">(등록된 내용은 채용 절차 진행 이외의 용도로는 사용되지 않습니다.)</p>
                    </div>
                  </div>

                  <div v-if="publicPop" class="publicPop">
                    <div class="publicText">
                      <strong class="publicTitle">개인정보보호정책</strong>
                      <p class="spaceTop">주) 플립커뮤니케이션즈의 개인정보취급방침은 다음과 같은 내용을 담고 있습니다.</p>

                      <div class="publicSection">
                        <p class="spaceTop">가. 수집하는 개인정보 항목 및 수집방법</p>
                        <p>(주)플립커뮤니케이션즈는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.</p>
                        <ul class="publicList">
                          <li class="spaceTop">
                            ・ 프로젝트 제작문의 : 회사명, 웹사이트, 담당자, 직위, 소속부서, 전화, 휴대폰, 이메일, 의뢰내용, 첨부파일
                          </li>
                          <li>・ 온라인채용 : 이름, 지원분야, 전화, 휴대폰, 이메일, 이력서첨부, 사진첨부, 기타사항, 희망연봉</li>
                          <li>・ 뉴스레터 : 이름, 소속, 이메일</li>
                        </ul>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">또한 서비스 이용과정이나 사업 처리 과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다.</p>
                        <ul class="publicList">
                          <li class="spaceTop">・ 서비스 이용기록, 접속 로그, 쿠키, 접속 IP 정보</li>
                        </ul>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">(주)플립커뮤니케이션즈는 다음과 같은 방법으로 개인정보를 수집합니다.</p>
                        <ul class="publicList">
                          <li class="spaceTop">・ 홈페이지를 통한 개인정보 입력</li>
                          <li>・ 생성정보 수집 툴을 통한 수집</li>
                        </ul>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">나. 개인정보 수집 및 이용목적</p>
                        <p>(주)플립커뮤니케이션즈는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>
                        <ul class="publicList">
                          <li class="spaceTop">
                            <p>・ 마케팅 및 광고에 활용</p>
                            <span
                              >신규 서비스(제품) 개발 및 특화, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 회원의 서비스 이용에 대한 통계,
                              이벤트 등 광고성 정보 전달</span
                            >
                          </li>
                          <li>
                            <p>・ 프로젝트 제작문의</p>
                            <span>회원님의 프로젝트에 대한 견적, 기간, 개발방법 등의 문의에 대한 답변</span>
                          </li>
                          <li>
                            <p>・ 채용</p>
                            <span>상시 인력채용을 위한 인재풀 유지다. 개인정보의 공유 및 제공</span>
                          </li>
                        </ul>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">다. 개인정보의 공유 및 제공</p>
                        <p>(주)플립커뮤니케이션즈는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.</p>
                        <ul class="publicList">
                          <li class="spaceTop">- 이용자들이 사전에 동의한 경우</li>
                          <li>- 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
                        </ul>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">라. 수집한 개인정보 취급 위탁</p>
                        <p>
                          (주) 플립커뮤니케이션즈는 고객님의 동의없이 고객님의 개인정보 취급을 외부 업체에 위탁하지 않습니다. 향후 그러한 필요가 생길
                          경우, 위탁 대상자와 위탁 업무 내용에 대해 고객님에게 통지하고 필요한 경우 사전 동의를 받도록 하겠습니다.
                        </p>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">마. 수집한 개인정보의 보유 및 이용기간</p>
                        <p>
                          원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 단, 다음의 정보에 대해서는 아래의
                          이유로 명시한 기간 동안 보존합니다.
                        </p>
                        <p class="spaceTop">&lt;내부 방침에 의한 정보보유 사유&gt;</p>
                        <ul class="publicList">
                          <li>
                            <p>・ 회원 E-mail</p>
                            <div>
                              <ul>
                                <li>- 보존 이유 : 신규서비스 안내 등의 뉴스레터 발송</li>
                                <li>- 보존 기간 : 메일 수신 거부시까지</li>
                              </ul>
                            </div>
                          </li>
                          <li>
                            <p>・ 채용정보</p>
                            <div>
                              <ul>
                                <li>- 보존 이유 : 회원님의 동의를 통한 인재정보 유지</li>
                                <li>- 보존 기간 : 회원정보 삭제 요청시까지</li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">바. 개인정보 파기절차 및 방법</p>
                        <p>
                          (주)플립커뮤니케이션즈는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및
                          방법은 다음과 같습니다.
                        </p>
                        <ul class="publicList">
                          <li class="spaceTop">
                            <p>・ 파기절차</p>
                            <div>
                              <ul>
                                <li>
                                  - 회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에
                                  따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다.
                                </li>
                                <li>- 동 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.</li>
                              </ul>
                            </div>
                          </li>
                          <li>
                            <p>・ 파기방법</p>
                            <div>
                              <ul>
                                <li>- 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기하고</li>
                                <li class="spaceTop">
                                  - 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">사. 이용자 및 법정 대리인의 권리와 그 행사방법</p>
                        <p>
                          이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며
                          가입해지를 요청할 수도 있습니다.
                        </p>
                        <p>개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다.</p>
                        <p>
                          귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다.
                          또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록
                          하겠습니다.
                        </p>
                        <p class="spaceTop">
                          (주) 플립커뮤니케이션즈는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 “(주)플립커뮤니케이션즈가
                          수집하는 개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고
                          있습니다.
                        </p>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">아. 개인정보의 자동 수집 장치의 설치ㆍ운영 및 그 거부에 관한 사항</p>
                        <ul class="publicList">
                          <li>
                            (주) 플립커뮤니케이션즈는 귀하의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’라는 개인정보를 자동으로 수집하는 장치를
                            설치ㆍ운용합니다. 쿠키란 (주)플립커뮤니케이션즈의 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은
                            텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다.
                          </li>
                        </ul>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">(주)플립커뮤니케이션즈은 다음과 같은 목적을 위해 쿠키 등을 사용합니다.</p>
                        <ul class="publicList">
                          <li class="spaceTop">
                            <p>・ 쿠키 등 사용 목적</p>
                            <div>
                              <ul>
                                <li>
                                  - 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여
                                  정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공
                                </li>
                              </ul>
                            </div>
                          </li>
                          <li>
                            <p class="spaceTop">
                              귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를
                              허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
                            </p>
                            <p class="spaceTop">쿠키 설정 거부 방법</p>
                            <div>
                              <ul>
                                <li>
                                  <p>
                                    예: 쿠키 설정을 거부하는 방법으로는 회원님이 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나
                                    쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
                                  </p>
                                  <p>설정방법 예(인터넷 익스플로어의 경우): 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보</p>
                                </li>
                              </ul>
                            </div>
                            <p class="spaceTop">단, 귀하께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.</p>
                          </li>
                        </ul>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">자. 개인정보 관리 책임자</p>
                        <p>
                          (주)플립커뮤니케이션즈는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및
                          개인정보관리책임자를 지정하고 있습니다.
                        </p>
                        <ul class="publicList">
                          <li>
                            <p class="spaceTop">・ 개인정보관리책임자</p>
                            <div>
                              <ul>
                                <li>성명 : 이성헌 이사</li>
                                <li>전화번호 : 02-541-4642(0409)</li>
                                <li>이메일 : iholydream@pulipinc.com</li>
                              </ul>
                            </div>
                            <p>또는</p>
                            <p>・ 개인정보담당부서</p>
                            <div>
                              <ul>
                                <li>성명 : 윤지환 팀장</li>
                                <li>전화번호 : 02-541-4642(0404)</li>
                                <li>이메일 : mgtyun@pulipinc.com</li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div class="publicSection">
                        <p class="spaceTop">
                          귀하께서는 (주)플립커뮤니케이션즈사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은
                          담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
                        </p>
                        <ul class="publicList">
                          <li class="spaceTop">공고일자 : 2009년 07월 13일</li>
                          <li>시행일자 : 2009년 07월 13일</li>
                        </ul>
                      </div>
                    </div>

                    <div class="publicClose">
                      <a href="javascript:;" @click.prevent="publicPop = false" />
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div class="btnArea">
              <a href="javascript:;" class="yellowLink" @click.prevent="addData">
                <span class="linkText">지원하기</span>
                <span class="linkIcon">
                  <img src="@/assets/images/@yellow_arrow.jpg" alt="" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import rules from '@/shared/mixin/rules.js';
import { sendPageViewAPI } from '@/store/modules/api/api';
export default {
  mixins: [rules],
  name: 'RecruitPop',
  data() {
    return {
      efClass: '',
      publicPop: false,
      expert: 'CON',
      pKPath: 'FRI',
      pKPathEtc: '',
      name: '',
      career: '',
      email: '',
      tel: '',
      file1Name: '',
      file2Name: '',
      file1: '',
      file2: '',
      agree: false,
      dontSend: false
    };
  },
  components: {},
  computed: {
    ...mapState('common', {
      recruitPop: state => state.recruitPop
    }),
    ...mapState('api', {
      addRecruitStatus: state => state.addRecruitStatus
    })
  },
  watch: {
    recruitPop(newValue) {
      if (newValue) {
        this.efClass = 'active';
      } else {
        this.efClass = 'leave';
        setTimeout(() => {
          this.efClass = '';
        }, 600);
      }
    },
    addRecruitStatus(newValue) {
      if (newValue === 'SUCCESS') {
        this.expert = 'CON';
        this.pKPath = 'FRI';
        this.pKPathEtc = '';
        this.name = '';
        this.career = '';
        this.email = '';
        this.tel = '';
        this.file1Name = '';
        this.file2Name = '';
        this.file1 = '';
        this.file2 = '';
        this.dontSend = false;
        alert('등록되었습니다.');
      } else if (newValue === 'FAIL') {
        this.dontSend = false;
        alert('오류가 발생하였습니다\n다시 시도하여 주십시오.');
      }
    }
  },
  methods: {
    ...mapActions('api', {
      addRecruitAction: 'addRecruit'
    }),
    file1Change(e) {
      this.file1 = e.target.files[0];
      this.file1Name = e.target.files[0].name;
    },
    file2Change(e) {
      this.file2 = e.target.files[0];
      this.file2Name = e.target.files[0].name;
    },
    addData() {
      if (this.dontSend) {
        alert('전송중입니다. 잠시만 기다려주세요');
        return false;
      }
      if (this.name.toLowerCase().trim() === '') {
        alert('성함을 입력해주세요!');
        return false;
      }
      if (this.tel.toLowerCase().trim() === '') {
        alert('연락처를 입력해주세요!');
        return false;
      }
      if (this.email.toLowerCase().trim() === '') {
        alert('이메일을 입력해주세요!');
        return false;
      }
      if (this.file1Name.toLowerCase().trim() === '') {
        alert('첨부파일을 추가해주세요!');
        return false;
      }
      if (!this.checkEmail(this.email)) {
        alert('이메일 형식에 맞게 입력해주세요.');
        return false;
      }
      if (!this.checkPhoneNo(this.tel.trim().replace(/[^0-9]/g, ''), this.tel.trim().substr(0, 2) === '01')) {
        alert('전화번호 형식에 맞게 입력해주세요.');
        return false;
      }
      if (!this.agree) {
        alert('개인 정보 수집•이용에 대해 동의해야 합니다.');
        return false;
      }
      const fd = new FormData();
      fd.append('expert', this.expert);
      fd.append('pKPath', this.pKPath);
      fd.append('pKPathEtc', this.pKPathEtc); // *
      fd.append('name', this.name);
      fd.append('career', this.career);
      fd.append('email', this.email);
      fd.append('tel', this.tel);
      fd.append('file1', this.file1);
      if (this.file2) fd.append('file2', this.file2); // *
      this.dontSend = true;
      this.addRecruitAction(fd);
      sendPageViewAPI(`recruit_submit`);
    }
  }
};
</script>
